export function viewMoreToggle() {
  const toggles = document.getElementsByClassName("view-more__button");
  [...toggles].map((item) => {
    item.addEventListener("click", function () {
      const parentContainer = this.closest(".show-view-more-mobile");
      parentContainer.classList.add("show-view-more-expanded");
      let nextElementToFocusId = "category-card__";
      window.screen.width < 1024
        ? (nextElementToFocusId += 4)
        : (nextElementToFocusId += 8);
      parentContainer.querySelector(`#${nextElementToFocusId}`).focus();
    });
  });
}
